var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDescuento(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "descuento",
    clipPath: "url(#clip0_6340_117996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.5 12.5L12.5 7.5",
    stroke: "#E2AA01",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.91667 8.33333C8.14679 8.33333 8.33333 8.14679 8.33333 7.91667C8.33333 7.68655 8.14679 7.5 7.91667 7.5C7.68655 7.5 7.5 7.68655 7.5 7.91667C7.5 8.14679 7.68655 8.33333 7.91667 8.33333Z",
    fill: "#E2AA01",
    stroke: "#E2AA01",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.0832 12.5003C12.3133 12.5003 12.4998 12.3138 12.4998 12.0837C12.4998 11.8535 12.3133 11.667 12.0832 11.667C11.8531 11.667 11.6665 11.8535 11.6665 12.0837C11.6665 12.3138 11.8531 12.5003 12.0832 12.5003Z",
    fill: "#E2AA01",
    stroke: "#E2AA01",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.16656 6.00038C4.16656 5.51415 4.35972 5.04784 4.70353 4.70402C5.04735 4.36021 5.51367 4.16705 5.9999 4.16705H6.83323C7.31731 4.16677 7.78164 3.97505 8.1249 3.63372L8.70823 3.05038C8.8786 2.87905 9.08116 2.74309 9.30426 2.65031C9.52736 2.55753 9.76661 2.50977 10.0082 2.50977C10.2499 2.50977 10.4891 2.55753 10.7122 2.65031C10.9353 2.74309 11.1379 2.87905 11.3082 3.05038L11.8916 3.63372C12.2348 3.97505 12.6991 4.16677 13.1832 4.16705H14.0166C14.5028 4.16705 14.9691 4.36021 15.3129 4.70402C15.6567 5.04784 15.8499 5.51415 15.8499 6.00038V6.83372C15.8502 7.3178 16.0419 7.78213 16.3832 8.12538L16.9666 8.70872C17.1379 8.87909 17.2739 9.08165 17.3666 9.30475C17.4594 9.52785 17.5072 9.76709 17.5072 10.0087C17.5072 10.2503 17.4594 10.4896 17.3666 10.7127C17.2739 10.9358 17.1379 11.1383 16.9666 11.3087L16.3832 11.8921C16.0419 12.2353 15.8502 12.6996 15.8499 13.1837V14.0171C15.8499 14.5033 15.6567 14.9696 15.3129 15.3134C14.9691 15.6572 14.5028 15.8504 14.0166 15.8504H13.1832C12.6991 15.8507 12.2348 16.0424 11.8916 16.3837L11.3082 16.9671C11.1379 17.1384 10.9353 17.2743 10.7122 17.3671C10.4891 17.4599 10.2499 17.5077 10.0082 17.5077C9.76661 17.5077 9.52736 17.4599 9.30426 17.3671C9.08116 17.2743 8.8786 17.1384 8.70823 16.9671L8.1249 16.3837C7.78164 16.0424 7.31731 15.8507 6.83323 15.8504H5.9999C5.51367 15.8504 5.04735 15.6572 4.70353 15.3134C4.35972 14.9696 4.16656 14.5033 4.16656 14.0171V13.1837C4.16629 12.6996 3.97456 12.2353 3.63323 11.8921L3.0499 11.3087C2.87856 11.1383 2.7426 10.9358 2.64982 10.7127C2.55704 10.4896 2.50928 10.2503 2.50928 10.0087C2.50928 9.76709 2.55704 9.52785 2.64982 9.30475C2.7426 9.08165 2.87856 8.87909 3.0499 8.70872L3.63323 8.12538C3.97456 7.78213 4.16629 7.3178 4.16656 6.83372V6.00038Z",
    stroke: "#E2AA01",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6340_117996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescuento);
export default __webpack_public_path__ + "static/media/descuento.68f069799074477a58feaae8333e24ef.svg";
export { ForwardRef as ReactComponent };